var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FF7600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9878 14.3125C11.3982 14.3125 9.24585 12.162 9.24585 9.61733C9.24585 6.98467 11.3982 4.83325 13.9887 4.83325C16.6672 4.83325 18.7306 6.98375 18.7306 9.61733C18.726 10.8668 18.2255 12.0633 17.339 12.9439C16.4526 13.8245 15.2528 14.3171 14.0034 14.3134L13.9878 14.3125ZM13.9878 7.59884C12.8914 7.59884 12.0573 8.52008 12.0573 9.61825C12.0573 10.7146 12.8914 11.5488 13.9887 11.5488C15.1299 11.5488 15.9201 10.7146 15.9201 9.61825C15.921 8.51917 15.1299 7.59884 13.9878 7.59884ZM15.8761 18.2193L18.5555 20.8089C19.0826 21.3782 19.0826 22.2123 18.5555 22.7394C17.9854 23.3087 17.1063 23.3087 16.6672 22.7394L13.9887 20.1058L11.3982 22.7394C11.1351 23.0025 10.7831 23.1336 10.3871 23.1336C10.08 23.1336 9.72894 23.0016 9.42094 22.7394C8.89385 22.2123 8.89385 21.3782 9.42094 20.808L12.1434 18.2184C11.1602 17.9273 10.2171 17.515 9.33569 16.991C8.6766 16.6399 8.54552 15.7627 8.8966 15.1036C9.33569 14.4454 10.1259 14.2703 10.8289 14.7094C11.781 15.2904 12.8747 15.5978 13.9901 15.5978C15.1054 15.5978 16.1991 15.2904 17.1512 14.7094C17.8543 14.2703 18.6875 14.4454 19.0826 15.1036C19.4786 15.7627 19.3017 16.639 18.6866 16.991C17.8534 17.5181 16.8872 17.9132 15.877 18.2203L15.8761 18.2193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.073efc166b03f582a0b9b803aab5fc92.svg";
export { ForwardRef as ReactComponent };